import script from "./ModalVincularAssinaturas.vue?vue&type=script&setup=true&lang=js"
export * from "./ModalVincularAssinaturas.vue?vue&type=script&setup=true&lang=js"

import "./ModalVincularAssinaturas.vue?vue&type=style&index=0&id=65b28c74&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-65b28c74"]])

export default __exports__